<template>
    <button
        type="button"
        class="tooltip-close flex"
        :class="[
            {
                'tooltip-close_danger': dangerAccent,
                'tooltip-close_hover-danger': hoverDanger,
                'tooltip-close_hover-blue': hoverBlue,
                'tooltip-close_danger-bold': dangerBold || dangerBoldHover,
                'tooltip-close_danger-bold-hover': dangerBoldHover
            },
            additionalClass
        ]"
        @click.prevent.stop="emitEvent"
    >
        <close-icon :bold="dangerBold || dangerBoldHover" :noColor="true" :fill="color" />
    </button>
</template>

<script>
import CloseIcon from "../../icons/CloseIcon"

export default {
    name: "CloseButtonSm",
    components: {
        CloseIcon
    },
    props: {
        additionalClass: [String],
        color: {
            type: String,
            default: "#2B2B2B"
        },
        hoverBlue: {
            type: Boolean,
            default: false
        },
        dangerAccent: {
            type: Boolean,
            default: false
        },
        dangerBold: {
            type: Boolean,
            default: false
        },
        dangerBoldHover: {
            type: Boolean,
            default: false
        },
        hoverDanger: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        emitEvent() {
            this.$emit("close")
            this.$emit("click")
            this.$emit("delete")
        }
    }
}
</script>
<style lang="sass" scoped>
.tooltip-close
    padding: 0
    height: 20px
    width: 20px
    display: flex
    align-items: center
    justify-content: center
    border-radius: 4px
    background: transparent
    transition: 0.1s
    cursor: pointer
    &.absolute
        z-index: 100
    svg
        pointer-events: none
        margin-right: 0 !important
        fill: #2B2B2B
        transition: 0.3s
        &.hovered-red
            fill: #EB6565 !important
    &:hover
        background-color: #fff
        box-shadow: 0 2px 5px rgba(128, 158, 191, 0.25)
        svg
            fill: #2B2B2B !important
            &.hovered-red
                fill: #DD4141 !important
    &_danger,
    &_danger:hover
        svg
            fill: #DD4141FF !important
    &_hover-blue
        box-shadow: none !important
        &:hover svg
            fill: #3965FF !important
    &_hover-danger
        box-shadow: none !important
        &:hover svg
            fill: #DD4141FF !important
    &_danger-bold
        border-radius: 50%
        width: 20px
        height: 20px
        display: flex
        margin-left: 8px
        align-items: center
        justify-content: center
        &:hover
            background-color: #FCECEC
            box-shadow: none
    &_danger-bold-hover
        background-color: #F3F3F3
        svg
            path
                transition: .1s
                fill: #323030
        &:hover
            background-color: #FCECEC
            svg
                path
                    fill: #DD4141
</style>
